package com.cybersoftsolution.cybersoftsolutionweb.use_cases

import com.cybersoftsolution.cybersoftsolutionweb.api.restorePassword
import com.cybersoftsolution.cybersoftsolutionweb.models.RestorePasswordParams
import com.cybersoftsolution.cybersoftsolutionweb.utils.WebStorage.rememberLogin
import kotlinx.coroutines.CoroutineScope
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch

fun CoroutineScope.restorePasswordUseCase(
    step:Int=1,
    setStep:(Int)->Unit,
    refreshOtpExpireInSec:(Long?)->Unit,
    restorePasswordParams: RestorePasswordParams =RestorePasswordParams(),
    setErrorText: (errorMessage:String) -> Unit,
    onSuccess: (successMessage:String?) -> Unit,
    onFail: (errorMessage:String) -> Unit,
){


    setErrorText(" ")

    this.launch {

        delay(500) // Simulate network request //Todo Quitar

        restorePassword(restorePasswordParams).also { it ->
            it?.let { response ->

                console.log(response)

                if (response.success==true) {


                    if ( (response.successMessage=="OTP sent" || response.successMessage=="OTP already sent") && response.otpExpireInSec!=null) {
                        setStep(2)
                        refreshOtpExpireInSec(response.otpExpireInSec)
                        when(response.successMessage){
                            "OTP sent" -> onSuccess("Código de verificación enviado, revise su bandeja de entrada")
                            "OTP already sent" -> onSuccess("Ya se envió el código de verificación, revise su bandeja de entrada")
                            else -> onSuccess(response.successMessage)
                        }
                    }

                    if (response.successMessage=="OTP verified") {
                        setStep(3)
                        onSuccess("Código de verificación correcto")
                    }

                    if (response.successMessage=="Password restored successfully") {
                        rememberLogin(
                            remember = true,
                            userId = response.userInfo?.id,
                            authorizationToken = response.userInfo?.authorizationToken,
                            userName = response.userInfo?.name,
                            userEmail = response.userInfo?.email,
                            userEmailVerified = response.userInfo?.emailVerified,
                            userPhone = response.userInfo?.phone,
                            userPicture = response.userInfo?.picture,
                        )
                        onSuccess("Contraseña restablecida y sesión iniciada")
                        setStep(-1)
                    }


                } else {


                    when(response.errorMessage){

                        "Invalid email" -> onFail("Por favor ingrese una dirección de correo válida").also { setStep(1) }
                        "User disabled" -> onFail("Usuario deshabilitado temporalmente, contacte a soporte").also { setStep(1) }
                        "User not found" -> onFail("No se encontró usuario con ese correo, por favor registrese").also { setStep(1) }

                        "OTP invalid" -> onFail("Código de verificación incorrecto").also { setStep(2) }
                        "OTP expired" -> onFail("Este código de verificación ha expirado").also { setStep(2) }
                        else -> onFail(response.errorMessage?: "Error desconocido")
                    }

                }




            }?:(
                    onFail("Error de conexion")
            )

        }


    }



}
